export default __webpack_public_path__ + "static/media/umb-com5.09ce5ace.jpg";